import { ArtworkImage } from './ArtworkImage';
import React, { useState } from 'react';
import type { UserAction } from '../api';
import { getItemImagePath } from './Card';
import { getItemKindFromCardType } from './StackedItemCard';
import { getDigitalItemArtworkPath } from '../utils/itemArtwork';
import { isMovementCompletion } from './digitalMapGame';

export function movementActionPresentation(action: UserAction) {
  const complete = isMovementCompletion(action);
  const undo = action.id === 'Undo_One' || action.id === 'Undo';
  const exchange = ['movement_item_exchange', 'item_exchange', 'exchange_money'].includes(action.id);
  const clueCount = action.cardType === 'Clue' && typeof action.card === 'number'
    && Number.isSafeInteger(action.card) && action.card > 0 ? action.card : undefined;
  const kind = getItemKindFromCardType(action.cardType);
  const card = action.card && typeof action.card === 'object' && !Array.isArray(action.card) ? action.card : undefined;
  const artwork = !complete && !undo && !exchange && kind && ['common', 'unique', 'spell', 'ally', 'special'].includes(kind)
    && card?.name ? getDigitalItemArtworkPath(getItemImagePath(kind, card.name, 'isNodensBlessing' in card && !!card.isNodensBlessing)) : '';
  return { kind: complete ? 'Complete' : undo ? 'Undo' : exchange ? 'Exchange' : clueCount ? 'Clue' : artwork ? 'Item' : 'Unknown', artwork, clueCount,
    style: { '--action-background': complete ? '#22c55e' : action.color || '#f1d995',
      '--action-color': complete ? '#22c55e' : action.color || '#cd37e1',
      color: complete ? '#fff' : '#172a2c' } as React.CSSProperties };
}

export function MovementActionIcon({ action, completion = false }: { action: UserAction; completion?: boolean }) {
  const presentation = movementActionPresentation(action);
  const { artwork, clueCount } = presentation;
  const kind = completion ? 'Complete' : presentation.kind;
  const [failedArtwork, setFailedArtwork] = useState('');
  const undoCount = action.id === 'Undo' ? action.name.match(/^Undo\s+([1-9]\d*)\s+actions?$/i)?.[1] : undefined;
  return <span className="movement-action-icon" aria-hidden="true">
    {kind === 'Clue' ? <><ArtworkImage src="/Clue.png" alt="" draggable={false} />
      {clueCount! > 1 && <b className="movement-action-clue-count">{clueCount}</b>}</>
      : artwork && failedArtwork !== artwork ? <img src={artwork} alt="" draggable={false} onError={() => setFailedArtwork(artwork)} />
      : kind === 'Complete' ? <svg viewBox="0 0 24 24" focusable="false"><path d="m5 12 4 4L19 6" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" /></svg>
        : kind === 'Undo' ? <svg viewBox="0 0 24 24" focusable="false">
          <path d="M5.6 5.6a9 9 0 1 1-2.5 7.7" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
          <path d="M2.5 2.5v7h7Z" fill="currentColor" />
          {undoCount && <text x="12" y="12.5" dy=".35em" textAnchor="middle" fill="currentColor"
            fontFamily="system-ui, sans-serif" fontWeight="800" fontSize={undoCount.length === 1 ? 10 : undoCount.length === 2 ? 8 : 6}
            textLength={undoCount.length > 2 ? 12 : undefined} lengthAdjust="spacingAndGlyphs">{undoCount}</text>}
        </svg>
        : <span>{kind === 'Exchange' ? '$' : '?'}</span>}
  </span>;
}
